import { graphql, useStaticQuery } from "gatsby"

export const useSiteMetadata = () => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteRoot
            author
            imageKitURL
            useMailChimpFooterNewsletter
            useHarrimanHouseTheme
            useBookBuy
            useBookBuyStaging
            bookBuyApiKey
            social {
              facebook
              twitter
              instagram
              soundcloud
              youtube
              tiktok
            }
          }
        }
      }
    `,
  );
  
  return data.site.siteMetadata
}